<div id="m4td-hero">
    @for (box of boxes(); track $index) {
    <div class="m4td-half">
        <img class="m4td-cam-img" [src]="box.img">
        <div class="m4td-section-container">
            <img class="m4td-cam-logo" [src]="box.titleImgRoute">
            @for (section of box.sections; track $index) {
                <div class="m4td-section-text-container">
                    <h4 class="m4td-section-title">{{section.title}}</h4>
                    <div class="m4td-section-content">
                        {{section.content}}
                    </div>
                </div>
            }
        </div>
    </div>
    }
</div>